








































import { Vue, Component, Prop } from 'vue-property-decorator';
import { infoAppointmentRecord, addAppointmentRecord } from '@/api/visitor-car-management';
import ModalConfig from '@/components/modal-config/index.vue';
import moment from 'moment';

@Component({
  name: 'AppointmentBooking',
  components: {
    ModalConfig
  }
})
export default class AppointmentBooking extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ type: String }) appointmentId!: string;

  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  };

  form: any;
  loading;
  confirmLoading: boolean = false;
  appointmentData: Record<string, any> = {};

  get visitEndTime() {
    try {
      return moment((this.appointmentData as any).visitTime.split('至')[1]);
    } catch {
      return moment();
    }
  }

  disabledDate(current: any) {
    return current && this.visitEndTime.isAfter(current, 'day');
  }

  //提交表单
  async onSubmit() {
    this.form.validateFieldsAndScroll(async (err: any) => {
      if (!err) {
        const rangeTimePicker = this.form.getFieldValue('rangeTimePicker');
        const startTime = moment(rangeTimePicker[0]).format('YYYY-MM-DD HH:mm');
        const endTime = moment(rangeTimePicker[1]).format('YYYY-MM-DD HH:mm');
        const visitEndTime = (this.appointmentData as any).visitTime.split('至')[1];
        if (startTime.valueOf() < visitEndTime.valueOf()) {
          this.$message.error(`续约时间应在${visitEndTime}之后`);
          return;
        }
        this.confirmLoading = true;
        try {
          const {
            parkId,
            plateNo,
            visitor,
            visitorPhone,
            ownerName,
            ownerPhone,
            ownerRoomNo,
            remark,
            visitorType
          } = this.appointmentData;
          const { status } = await addAppointmentRecord({
            parkId,
            plateNos: plateNo.split(','),
            visitor,
            visitorPhone,
            ownerName,
            ownerPhone,
            ownerRoomNo,
            startTime,
            endTime,
            remark,
            visitorType
          });
          if (status === '9999') {
            this.$message.success('再次预约成功');
            this.visible = false;
            this.$emit('appointSuccess');
          }
        } catch (e) {
          this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
        } finally {
          this.confirmLoading = false;
        }
      }
    });
  }

  //取消
  onCancel() {
    this.visible = false;
  }

  get visible() {
    return this.value;
  }

  set visible(val) {
    this.$emit('input', false);
  }

  async getInfoAppointmentRecord(appointmentId: any) {
    try {
      const { status, data } = await infoAppointmentRecord({
        appointmentId
      });
      if (status === '9999') {
        this.appointmentData = data;
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }

  created() {
    this.getInfoAppointmentRecord(this.appointmentId);
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        return {
          rangeTimePicker: this.$form.createFormField({
            value: []
          })
        };
      }
    });
  }
}
